import { themeColor } from "../theme-helper";

const boxesBase = {
  backgrounds: {
    grey: {
      backgroundColor: themeColor("highlight"),
    },
    greyFilled: {
      backgroundColor: themeColor("boxes.greyBgFilled"),
    },
    primaryHighlight: {
      borderLeft: `solid 2px ${themeColor("primary")}`,
      backgroundColor: themeColor("highlight"),
    },
    accordion: {
      backgroundColor: themeColor("boxes.accordion"),
      item: {
        backgroundColor: themeColor("boxes.accordionItem"),
      },
    },
  },
  logo: {
    filter: themeColor("logoFilter"),
  },
  header: {
    navbar: {
      boxShadow: "small",
      width: "100%",
      dropdown: {
        boxShadow: "small",
        borderRadius: "1",
        backgroundColor: themeColor("navbar.dropdown"),
      },
      menuIcon: {
        width: "48px",
        alignItems: "center",
        transform: "rotate(0deg)",
        transition: ".5s ease-in-out",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        span: {
          height: "2px",
          width: "24px",
          alignItems: "center",
          background: themeColor("primary"),
          borderRadius: "1",
          opacity: 1,
          transform: "rotate(0deg)",
          transition: ".25s ease-in-out",
          "&:nth-of-type(2)": { marginBottom: "6px", marginTop: "6px" },
        },
      },
      menuIconOpen: (theme: any) => ({
        ...theme.boxes.header.navbar.menuIcon,
        height: "48px",
        alignItems: "center",
        span: {
          ...theme.boxes.header.navbar.menuIcon.span,
          top: "20px",
          position: "absolute",
          "&:nth-of-type(1)": { transform: "rotate(135deg)" },
          "&:nth-of-type(2)": { opacity: 0 },
          "&:nth-of-type(3)": { transform: "rotate(-135deg)" },
        },
      }),
    },
  },
  footer: {
    borderRadius: "2",
  },
  lightbox: {
    ".zilch__lightbox-backdrop": {
      background: themeColor("variables.greys.80"),
    },
    ".zilch__lightbox-caption": {
      backgroundColor: themeColor("overlays.opacity"),
      fontSize: 2,
      fontWeight: "normal",
      color: themeColor("text"),
    },
  },
  slider: {
    boxShadow: "large",
    borderRadius: "0",
    slide: {
      backgroundColor: themeColor("muted"),
    },
    nav: {
      height: "1.75rem",
      fontSize: "0.5rem",
      "> .w-slider-dot": {
        backgroundColor: themeColor("boxes.greyBg"),
        borderRadius: "0",
        boxShadow: "small",
      },
      "> .w-slider-dot.w-active": {
        backgroundColor: themeColor("secondary"),
      },
    },
  },
  dividers: {
    vertical: {
      backgroundColor: themeColor("elements.hr"),
      width: "1px",
      alignSelf: "stretch",
    },
    horizontal: {
      alignSelf: "stretch",
      color: themeColor("elements.hr"),
    },
    circle: {
      color: "primary",
      marginLeft: "0.5rem",
      marginRight: "0.5rem",
    },
  },
  accordion: {
    horizontal: {
      color: themeColor("text"),
      borderColor: `${themeColor("elements.hr")} !important`,
    },
  },
  overlays: {
    opacity: {
      wrapper: {
        position: "absolute",
        inset: "0%",
        zIndex: "-1",
      },
      layer: {
        position: "absolute",
        inset: "0%",
        zIndex: "1",
        backgroundColor: themeColor("variables.greys.70"),
      },
    },
  },
  hoverContainer: {
    "@media screen and (min-width: 992px)": {
      "&:hover a": {
        color: `${themeColor("elements.hr")} !important`,
      },
      "&:hover a:hover": {
        color: `${themeColor("text")} !important`,
      },
    },
  },
};

export const boxes = {
  ...boxesBase,
  nav: boxesBase.header, // alias for header == nav
};
